





































































































































































































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { findRegions } from '@/commons/regionFinder';
import { Country, QuoteAddress, GenericOption } from '@/store/models';
import store from '@/store';
import { Validator } from 'vee-validate';
import user from '@/store/modules/user';
import GmapAutocomplete from '@/components/Address/GmapAutocomplete.vue';
import { placeFoundCallback } from '@/commons/gmap';
@Component({
  components: {
    GmapAutocomplete,
  },
})
export default class AddressForm extends Vue {
  @Inject() public $validator!: Validator;
  @Prop() private address!: QuoteAddress;
  @Prop() private addressType!: string;

  private userdataAgreement = false;
  private uniqId = '';

  private mounted() {
    this.uniqId =  Math.random().toString(36).substr(2, 9);
    const stateRequiredFor = store.state.options.countrysettings.state_required;
    if (this.isRegionOptional && !stateRequiredFor) {
      this.address.region = 'n/a';
    }
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get hasAddresses(): boolean {
    return user.hasAddresses;
  }

  get coutryRegions() {
    return findRegions(this.address.country_id);
  }

  get postcodeValidationRule(): string {
    return store.getters.postcodeValidationRule;
  }

  get telephoneValidationRule() {
    const rule: any = { required: true, numeric: true };
    if (store.state.options.countrysettings.telephonedigits) {
      rule.digits = store.state.options.countrysettings.telephonedigits;
    }
    return rule;
  }

  get countries(): Country[] {
    return store.state.countryData.countries;
  }

  get isRegionOptional(): boolean {
    return store.state.options.countrysettings.is_region_optional;
  }

  get telprefixes(): GenericOption[] {
    return store.state.options.telprefixes;
  }

  get userdatalabel(): string {
    return store.state.options.labels ? store.state.options.labels.userdata : false;
  }

  get disclaimerlabel(): string {
    return store.state.options.labels ? store.state.options.labels.disclaimer : false;
  }

  private placeFoundHandler(place: google.maps.places.PlaceResult) {
    placeFoundCallback(place, this.address);
  }
}
